import Vue from "vue";

/**
 * The ESLint rule vue/no-v-html disallows the use of v-html to prevent XSS
 * attacks via injecting potentially unsafe, unescaped HTML into the browser.
 *
 * This directive, inspired by React's dangerouslySetInnerHTML attribute
 * mitigating the same problem, is made available on all components.
 *
 * Setting HTML directly is therefore possible, but developers have to type out
 * dangerouslySetInnerHTML to remind themselves that it is dangerous.
 */
export default () => {
  Vue.directive("dangerouslySetInnerHTML", function (element, binding) {
    element.innerHTML = binding.value;
  });

  /**
   * Calls the bound handler when a click happens outside of the element the
   * directive is attached to. Used to dismiss click-toggled dropdowns/menus
   * (previously handled by Bulma's hover-based `.navbar-dropdown`/`is-hoverable`).
   *
   * Attach it to the wrapper that contains BOTH the toggle and the panel so the
   * opening click (which targets the toggle inside the element) is not treated
   * as an outside click.
   *
   * Usage: `<div v-click-outside="close">…</div>`
   */
  Vue.directive("click-outside", {
    bind(el, binding) {
      el.__clickOutsideHandler__ = (event) => {
        if (el !== event.target && !el.contains(event.target)) {
          binding.value(event);
        }
      };
      document.addEventListener("click", el.__clickOutsideHandler__);
    },
    unbind(el) {
      document.removeEventListener("click", el.__clickOutsideHandler__);
      delete el.__clickOutsideHandler__;
    },
  });
};
